import { $ } from '@/libs/jquery/index'
import { UTMFields } from '@/libs/utm_fields/index'

const baseSelector: string = '[data-selector="leadsUserCallback"]'

export class LeadsUserCallback {

  private base: JQuery | null = null

  private readonly selectors: ISelectors = {
    answer: '[data-selector="userCallBack"]',
    base: baseSelector,
    form: '[data-selector="leadsUserCallbackForm"]',
    submit: '[data-selector="leadsUserCallbackBtn"]',
  }

  constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  // Инициализация "компонента"
  public init(): void {
    UTMFields.wait().then(() => {
      UTMFields.fill()
      this.initValidationRules()
      this.initListeners()
    })
  }

  private initListeners(): void {
    this.base
      .on('ajax:success', this.selectors.form, () => this.showSuccess())
      .on('ajax:error', this.selectors.form, () => this.showFailure())
      .on('ajax:beforeSend', this.selectors.form, () => this.disableBtn())
  }

  // Наложить на форму правила валидации
  private initValidationRules(): void {
    this.base.find(this.selectors.form).validate()
  }

  private showSuccess(): void {
    this.showMessage('Спасибо за обращение! Наши менеджеры свяжутся с Вами в ближайшее время!')
  }

  private showFailure(): void {
    this.showMessage('Заявка не создана, пожалуйста, попробуйте позже.')
  }

  private disableBtn(): void {
    this.base.find(this.selectors.submit).prop('disabled', true)
  }

  private showMessage(message: string): void {
    UTMFields.clear()
    this.base.find(this.selectors.form)
      .slideUp('slow')
      .after(`<div class='userCallBack' data-selector='userCallBack'>${ message }</div>`)
    this.base.find(this.selectors.answer).slideDown('slow')
  }
}
